// extracted by mini-css-extract-plugin
export default {"container":"ControlPanel_container__86YN5"};